import React, { useMemo, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';

const Component = () => {
  const [searchParams] = useSearchParams();
  const initialToken = useMemo(() => searchParams.get('token') || '', [searchParams]);

  const [form, setForm] = useState({
    token: initialToken,
    password: '',
    confirmPassword: '',
  });
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  async function handleSubmit(event) {
    event.preventDefault();
    setError('');
    setSuccess('');
    if (form.password !== form.confirmPassword) {
      setError('Password confirmation does not match.');
      return;
    }

    setSaving(true);
    try {

      const Factory = require( '../../../records/auth' );

      const response = await Factory.resetPassword({
        token: form.token.trim(),
        password: form.password,
      });

      setSuccess(response.message || 'Password reset successfully.');
    } catch (err) {
      setError(err?.response?.data?.message || err.message || 'Unable to reset password.');
    } finally {
      setSaving(false);
    }
  }

  return (
    <div className="auth-shell">
      <form className="card auth-card stack" onSubmit={handleSubmit}>
        <div className="stack-sm">
          <h1 className="page-title">Reset password</h1>
          <p className="page-subtitle">Use your token and set a new password.</p>
        </div>

        {error ? <p className="error-text">{error}</p> : null}
        {success ? <p>{success}</p> : null}

        <label>
          Reset token
          <input
            value={form.token}
            onChange={(event) => setForm((prev) => ({ ...prev, token: event.target.value }))}
            required
          />
        </label>
        <label>
          New password
          <input
            autoComplete="new-password"
            type="password"
            value={form.password}
            onChange={(event) => setForm((prev) => ({ ...prev, password: event.target.value }))}
            required
          />
        </label>
        <label>
          Confirm new password
          <input
            autoComplete="new-password"
            type="password"
            value={form.confirmPassword}
            onChange={(event) => setForm((prev) => ({ ...prev, confirmPassword: event.target.value }))}
            required
          />
        </label>

        <button className="button-primary" disabled={saving} type="submit">
          {saving ? 'Resetting...' : 'Reset password'}
        </button>

        <Link className="inline-link" to="/login">Back to sign in</Link>
      </form>
    </div>
  );
};

export default Component;